import React, { Component } from 'react';
import { MDBIcon, MDBTooltip, MDBInput } from 'mdbreact';
import { ListTiposIdentificacion_, ListRedAgencias, GenerarOTPAsociado_, ValidarOTPSolicitud_, ObtenerInfoAsociado_, EnviarCorreoSolicitud_, ProductosUrlDireccionGET_, ProductosEncryptionKeyGET_ } from '../../services/WebAPI_Utrahuilca';
import Swal from 'sweetalert2';
import Header from '../Principal/Header';
import MensajeF from '../Mensaje_Flotante/MensajeF';
import Footer from '../Principal/Footer';
import Loading from '../Loading';
import Select from 'react-select';
import { getCustomSelectStyles } from '../../utils/selectStyles';

class FormSolicQrComercio extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errores: {},
            estadoSolicitud: true,
            ejecutaloading: false,
            asociadoverificado: false,
            titulo: 'Solicita tu Código QR Comercio',
            tiposid: [],
            redagencias: [],
            cuentasahorro: [],
            urlvinculacion: null,
            campos: {
                idtipodoc: 0,
                tipodocumento: '',
                iddocumento: '',
                numerocelular: '',
                correo: '',
                nombres: '',
                apellidos: '',
                agencia: 0,
                idcodprocuenta: 0,
                llaveid: 0,
                llaveusuario: '',
                actividadcomercio: '',
                idagenciaentrega: 0
            },
            opciones: {
                idtipodoc: null,
                idcodprocuenta: null,
                idagenciaentrega: null
            }
        };
    }

    async componentDidMount() {
        await this.CargarTipoIdentificacion();
        await this.CargarListaAgencias();
        await this.CargarRedirecciónVinculacion();
    }

    MostrarModal = (titulo, mensaje = '', idicono = 0) => {
        let iconos = ['error', 'success', 'warning'];
        Swal.fire({
            icon: iconos[idicono],
            title: titulo,
            html: mensaje
        });
    }

    CargarTipoIdentificacion = async () => {
        const datos = {tran: 6, idtipodoc: 0, abreviatura: 'N/A', desctipodoc: 'N/A', abrevutraweb: 'N/A', idtipopers: 0, estado: 1};
        try {
            const registros = await ListTiposIdentificacion_(datos);
            const cantregistros = registros?.length ?? 0;
            const sinresultados = registros[0]?.message === '004404';
            if (cantregistros > 0 && !sinresultados) {
                let tiposid = [];
                for (const tipoid of registros) {
                    tiposid.push({ value: tipoid.idtipodoc, label: tipoid.desctipodoc, abrevutraweb: tipoid.abrevutraweb });
                }
                this.setState({
                    tiposid
                });
            }
        }
        catch {
            this.MostrarModal('Ocurrio un error!');
        }
    }

    CargarListaAgencias = async () => {
        const datos = { prmto: 8, redAgencia: 0, tipoAgencia: 0, municipio: 0, estado: 1, usuario: 0 };
        try {
            const peticion = await ListRedAgencias(datos);
            const registros = peticion.data;
            const cantregistros = registros?.length ?? 0;
            const sinresultados = registros[0]?.message === '004404';
            if (cantregistros > 0 && !sinresultados) {
                let redagencias = [];
                for (const agencia of registros) {
                    const { idredagencia, nombreagencia } = agencia;
                    redagencias.push({ value: idredagencia, label: `${idredagencia} - ${nombreagencia}` });
                }
                this.setState({
                    redagencias
                });
            }
        }
        catch {
            this.MostrarModal('Ocurrio un error!');
        }
    }

    CargarRedirecciónVinculacion = async () => {
        const dataUrlDireccion = { tran: 5, idurl: 0, direccionurl: "N/A", identificador: "PaginaWeb", estado: 1 };
        try {
            const peticion = await ProductosUrlDireccionGET_(dataUrlDireccion);
            const largourl = peticion?.data?.length ?? 0;
            if (largourl > 0) {
                this.setState({
                    urlvinculacion: peticion.data
                });
            }
        }
        catch {
            this.MostrarModal('Ocurrio un error!');
        }
    }

    TextInput = (evento) => {
        const campo = evento.target.name;
        let valor = evento.target.value
        if (valor.length > 0) {
            if (campo === 'iddocumento' || campo === 'numerocelular') {
                valor = campo === 'iddocumento' && this.state.campos.idtipodoc === 8 ? valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase() : valor.replace(/[^0-9]/g, ''); // En el número de identificación se permite agregar texto cuando es "PASAPORTE" (8).
            }
            else if (campo === 'actividadcomercio') {
                valor = valor.replace(/[^a-zA-Z ]/g, '');
            }
        }
        this.setState({
            campos: {
                ...this.state.campos,
                [campo]: valor
            }
        });
    }

    SelectInput = (selected, campo) => {
        this.setState({
            opciones: {
                ...this.state.opciones,
                [campo]: selected || null
            },
            campos: {
                ...this.state.campos,
                [campo]: selected?.value || 0,
                tipodocumento: campo === 'idtipodoc' ? selected?.abrevutraweb || '' : this.state.campos.tipodocumento
            }
        });
    }

    VerificarAsociado = async () => {
        const { idtipodoc, tipodocumento, iddocumento, numerocelular } = this.state.campos;
        if (idtipodoc !== 0 && iddocumento !== '' && numerocelular !== '') {
            const data = { tipoiden: tipodocumento, nit: iddocumento, numerocelular, idtipodoc };
            this.setState({
                ejecutaloading: true,
            });
            try {
                const peticion = await GenerarOTPAsociado_(data);
                const mensaje = peticion[0]?.desresp || '';
                this.setState({
                    ejecutaloading: false
                });
                if (mensaje !== '') {
                    const asociado = mensaje.split("|")[0];
                    const titulo = mensaje.split("|")[1];
                    const cuerpo = mensaje.split("|")[2];
                    if (asociado !== '0') {
                        if (peticion[0].codresp === '000000') {
                            this.setState({
                                id_cod_otp: parseInt(peticion[0].codigo),
                                desccodotp: mensaje,
                                idintentoverif: parseInt(peticion[0].idintento)
                            });
                            await this.ValidarOTP();
                        }
                        else if (asociado === '2') {
                            this.MostrarModal(titulo, cuerpo, 2);
                        }
                        else {
                            await this.RedireccionarVinculacion(titulo, cuerpo, 2);
                        }
                    }
                    else {
                        await this.RedireccionarVinculacion(titulo, cuerpo, 1);
                    }
                }
                else {
                    this.MostrarModal('Ocurrio un error!', `<span style="text-align: justify">Comunícate con nuestro centro de contacto. <a className="text-dark" rel="noopener noreferrer" target="_blank" href="https://api.whatsapp.com/send?phone=573102100828">Aquí.</a></span>`);
                }
            }
            catch (error) {
                this.MostrarModal('Ocurrio un error!');
            }
            finally {
                this.setState({
                    ejecutaloading: false
                });
            }
        }
    }

    RedireccionarVinculacion = async (titulo, mensaje, proceso) => {
        Swal.fire({
            icon: 'question',
            title: titulo,
            html: mensaje,
            showCancelButton: true,
            showCloseButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: proceso === 1 ? 'Vincularme' : 'Actualizar datos',
            cancelButtonText: 'Cancelar',
            cancelButtonColor: '#008694',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const peticion = await ProductosEncryptionKeyGET_({ parametros: `param=${proceso}` });
                const parametrourl = peticion?.data || '';
                if (parametrourl !== '' && this.state.urlvinculacion !== '') {
                    window.open(`${this.state.urlvinculacion}${parametrourl}`);
                }
            }
        });
    }

    ValidarOTP = async () => {
        Swal.fire({
            icon: 'info',
            title: 'Ingresa el código de verificación',
            html:
                `<span style="text-align: justify">${this.state.desccodotp}</span>
                 <input type="text" id="codigo_otp" class="swal2-input" maxLength="4" placeholder="Ingrese el código" pattern="[0-9]" autocomplete="false" onKeypress="if (event.keyCode < 45 || event.keyCode > 57) event.returnValue = false;">
                `,
            showCancelButton: true,
            showCloseButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            confirmButtonText: 'Validar',
            cancelButtonText: 'Reenviar Código',
            cancelButtonColor: '#008694',
            showLoaderOnConfirm: true,
            inputAttributes: {
                autocapitalize: 'off'
            },
            preConfirm: async () => {
                const data = {
                    id_cod_otp: this.state.id_cod_otp,
                    cod_mot_otp: 11,
                    codigo_otp: parseInt(Swal.getPopup().querySelector('#codigo_otp').value),
                    idintento: this.state.idintentoverif
                };
                this.setState({
                    ejecutaloading: true
                });
                try {
                    const validacionotp = await ValidarOTPSolicitud_(data);
                    const { codresp, desresp } = validacionotp[0];
                    if (codresp === '000000') {
                        await this.PrecargarFormulario();
                    }
                    else {
                        this.setState({
                            ejecutaloading: false
                        })
                        Swal.fire({
                            icon: 'warning',
                            title: desresp,
                            showCancelButton: false,
                            confirmButtonText: `Intentar nuevamente`,
                            confirmButtonColor: '#f47216',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.VerificarAsociado();
                            }
                        });
                    }
                }
                catch (error) {
                    this.MostrarModal('Ocurrio un error!');
                }
                finally {
                    this.setState({
                        ejecutaloading: false
                    });
                }
            },
        }).then((result) => {
            if (result.dismiss !== 'close') {
                if (!result.isConfirmed) {
                    this.VerificarAsociado();
                }
            } else {
                this.setState({
                    tipoiden: 0,
                    nit: '',
                    numerocelular: ''
                });
            }
        });
    }

    PrecargarFormulario = async () => {
        const { id_cod_otp, idintentoverif, campos } = this.state;
        const data = { idtipodoc: campos.idtipodoc, tipoiden: campos.tipodocumento, nit: campos.iddocumento, idintento: idintentoverif, id_cod_otp };
        const peticion = await ObtenerInfoAsociado_(data);
        const cantregistros = Object.keys(peticion)?.length ?? 0;
        if (cantregistros > 0) {
            const { cuentas, asociado } = peticion;
            if (cuentas && asociado) {
                let cuentasahorro = [];
                for (const cuenta of cuentas) {
                    cuentasahorro.push({ value: cuenta.codpro, label: cuenta.cuenta });
                }
                this.setState({
                    asociadoverificado: true,
                    cuentasahorro,
                    campos: {
                        ...this.state.campos,
                        nombres: asociado[0].nombres,
                        apellidos: asociado[0].apellidos,
                        correo: asociado[0].correo,
                        numerocelular: asociado[0].telcel,
                        agencia: asociado[0].agencia
                    }
                });
            }
            else {
                this.MostrarModal('Ocurrio un error al consultar al asociado! Intentalo nuevamente.');
            }
        }
        else {
            this.MostrarModal('Ocurrio un error!');
        }
    }

    EnviarCorreo = async () => {
        const { idintentoverif, campos, redagencias } = this.state;
        const { idtipodoc, tipodocumento, iddocumento, llaveid, llaveusuario, actividadcomercio, idcodprocuenta, idagenciaentrega } = campos;
        const data = {
            tipodoc: tipodocumento,
            nit: iddocumento,
            llave: `${llaveid};${llaveusuario}`,
            agenciaentrega: redagencias.find(agencia => idagenciaentrega === agencia.value)?.label,
            idintento: idintentoverif,
            idagenciaentrega,
            idtipodoc,
            actividadcomercio,
            idcodprocuenta,
            asunto: 'Solicitud de Creación del Código QR de Comercio'
        };
        this.setState({
            ejecutaloading: true,
        });
        try {
            const peticion = await EnviarCorreoSolicitud_(data);
            if (peticion[0].codresp === '000000') {
                this.setState({
                    asociadoverificado: false,
                    solicitudaceptada: false,
                    campos: {
                        idtipodoc: 0,
                        tipodocumento: '',
                        iddocumento: '',
                        numerocelular: '',
                        correo: '',
                        nombres: '',
                        apellidos: '',
                        agencia: 0,
                        idcodprocuenta: 0,
                        llaveid: 0,
                        llaveusuario: '',
                        actividadcomercio: '',
                        idagenciaentrega: 0
                    },
                    opciones: {
                        idtipodoc: null,
                        idcodprocuenta: null,
                        idagenciaentrega: null
                    }
                });
                this.MostrarModal(peticion[0].desresp, 'Hemos recibido tu solicitud correctamente. Próximamente nos comunicaremos contigo para confirmar la agencia donde podrás reclamar el material de tu <b>Código QR Comercio</b>.<br><br>Gracias por utilizar los servicios de UTRAHUILCA.', 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
            else {
                this.MostrarModal('Advertencia', peticion[0]?.desresp || 'Ocurrio un inconveniente al enviar la solicitud. Intentalo nuevamente', 2);
            }
        }
        catch (error) {
            this.MostrarModal('Ocurrio un error!');
        }
        finally {
            this.setState({
                ejecutaloading: false
            });
        }
    }

    render() {
        const { ejecutaloading, tiposid, redagencias, cuentasahorro, titulo, campos, opciones, asociadoverificado, solicitudaceptada } = this.state;
        const { idtipodoc, iddocumento, correo, nombres, apellidos, numerocelular, agencia, idcodprocuenta, llaveid, llaveusuario, actividadcomercio, idagenciaentrega } = campos;

        const tiposllave = [
            { value: 1, label: 'Número de Teléfono Celular', llave: numerocelular },
            { value: 2, label: 'Correo electrónico', llave: correo },
            { value: 3, label: 'Documento de Identidad', llave: `****${iddocumento.slice(-4)}` },
            { value: 4, label: 'Alfanumérica', llave: '' }
        ];

        const direccionmodulo = <span className="pt-4 font-weight-bold" style={{ fontSize: '20px', position: 'absolute', top: '130px', left: '10px' }}>
                                    <MDBIcon icon="caret-right" className="ml-2 mr-1" /> Personas
                                    <MDBIcon icon="caret-right" className="ml-2 mr-1" /> {titulo}
                                </span>;
        const infomodulo =  <div className="bg-white solicitud_credito" style={{ width: '100%', paddingTop: '190px' }}>
                                <div className="container-fluid px-5">
                                    <p className="texto1" style={{ fontSize: '60px', color: '#747373' }}>{titulo}</p>
                                    <p className="texto2 text-justify">Recibe pagos electrónicos de forma rápida, fácil y segura en tu establecimiento comercial. A través de este formulario podrás solicitar gratuitamente la generación de tu código QR comercio UTRAHUILCA.</p>
                                    <p className="texto2 text-justify mb-1">Antes de iniciar la solicitud, verifica que cumplas estos requisitos:</p>
                                    <ul className="pl-4">
                                        <li>Tener tus datos personales y de contacto actualizados en el último año.</li>
                                        <li>Registro activo y acceso a la aplicación de la Red Coopcentral.</li>
                                        <li>Llave Bre-B activa asociada a tu cuenta de ahorros.</li>
                                    </ul>
                                    <p className="texto2 text-justify pb-4">Si cumples con estos requisitos, diligencia el formulario y envía tu solicitud.</p>
                                </div>
                            </div>;

        let campollave = <MDBInput type="text" className="text-postulate" label="Selecciona un tipo de llave" value="" disabled={true} autoComplete="off" />;
        if (llaveid === 1 || llaveid === 2 || llaveid === 3) {
            campollave = <MDBInput name="llaveusuario" value={tiposllave.find(tipollave => llaveid === tipollave.value)?.llave ?? ''} onChange={this.TextInput} disabled={true} type="text" className="mt-0" />
        }
        else if (llaveid === 4) {
            campollave = <MDBInput name="llaveusuario" type="text" className="text-postulate" label="Ingresa la llave alfanumérica." value={llaveusuario} maxLength="160" onChange={this.TextInput} autoComplete="off" />;
        }
        const seccionllave =    <div className="col-12">
                                    <div className="row d-flex align-items-center position-relative border rounded shadow-sm mb-4">
                                        <span className="position-absolute bg-white px-2" style={{ top: "-13px", left: "15px", fontWeight: 500 }}>
                                            <b>Selecciona la Llave asociada a la Cuenta de Ahorros seleccionada</b>
                                        </span>
                                        <span className="pt-5 pt-sm-4 pt-md-4 mx-4">
                                            <strong style={{ fontWeight: 'bold' }}>Importante:</strong> Verifica en la App Coopcentral el número de cuenta y la llave asociada para asegurarte de seleccionar la información correcta.
                                        </span>
                                        <div className="col-xl-9 col-lg-9 col-md-6 col-sm-6 col-12 d-flex flex-wrap pt-2">
                                            {tiposllave.map(llave => (
                                                <div key={llave.value} className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                                                    <div className="form-check form-check-inline d-flex align-itms-center">
                                                        <input
                                                            className="form-check-input m-0" type="radio" name="llaveid" value={llave.value} checked={llaveid === llave.value}
                                                            onChange={evento => { this.setState({ campos: { ...campos, llaveid: parseInt(evento?.target?.value ?? 0) } }) }} style={{ accentColor: "#F59A00", backgroundColor: "#FFF" }}
                                                        />
                                                        <label className="form-check-label ml-1"> {llave.label} </label>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12 pt-2">
                                            <label className="title-label form-label d-block fw-bold mb-1">Llave <span className="text-danger">*</span></label>
                                            {campollave}
                                        </div>
                                    </div>
                                </div>;

        const formulario =  <div className="row px-5">
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <label className="title-label form-label d-block fw-bold mb-1">Tipo de Documento <span className="text-danger">*</span></label>
                                    <Select
                                        className="react-select-container" name="idtipodoc" options={tiposid} styles={getCustomSelectStyles()}
                                        value={opciones.idtipodoc} placeholder="Selecciona…" onChange={selected => this.SelectInput(selected, 'idtipodoc')}
                                        isDisabled={asociadoverificado}
                                        isClearable
                                    />
                                </div>
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <label className="title-label form-label d-block fw-bold mb-1">Número de Identificación <span className="text-danger">*</span></label>
                                    <MDBInput name="iddocumento" type="text" hint="Ingresa tu número de identificación." value={iddocumento} disabled={asociadoverificado} maxLength="20" onChange={this.TextInput} />
                                </div>
                                {asociadoverificado && <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <p className="font-weight-bold mb-0 pb-0">Nombres </p>
                                    <MDBInput name="nombres" value={nombres} disabled={true} type="text" className="mt-0" />
                                </div>}
                                {asociadoverificado && <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <p className="font-weight-bold mb-0 pb-0">Apellidos </p>
                                    <MDBInput name="apellidos" value={apellidos} disabled={true} type="text" className="mt-0" />
                                </div>}
                                <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <label className="title-label form-label d-block fw-bold mb-1">Número de Teléfono Celular <span className="text-danger">*</span></label>
                                    <MDBInput name="numerocelular" type="text" hint="Ingresa tu número de teléfono celular." value={numerocelular} disabled={asociadoverificado} maxLength="10" onChange={this.TextInput} />
                                </div>
                                {asociadoverificado && <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <p className="font-weight-bold mb-0 pb-0">Correo Electrónico </p>
                                     <MDBInput name="correo" value={correo} disabled={true} type="text" className="mt-0" />
                                </div>}
                                {asociadoverificado && <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <p className="font-weight-bold mb-0 pb-0">Agencia </p>
                                     <MDBInput name="correo" value={agencia} disabled={true} type="text" className="mt-0" />
                                </div>}
                                {asociadoverificado && <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <label className="title-label form-label d-block fw-bold mb-1">Cuenta de Ahorros <span className="text-danger">*</span></label>
                                    <Select
                                        className="react-select-container" name="idcodprocuenta" options={cuentasahorro} styles={getCustomSelectStyles()}
                                        value={opciones.idcodprocuenta} placeholder="Selecciona…" onChange={selected => this.SelectInput(selected, 'idcodprocuenta')}
                                        isClearable
                                    />
                                </div>}
                                {asociadoverificado && seccionllave}
                                {asociadoverificado && <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <label className="title-label form-label d-block fw-bold mb-1">Actividad Económica del Comercio <span className="text-danger">*</span></label>
                                    <MDBInput name="actividadcomercio" type="text" className="text-postulate" label="Restaurante, venta de artículos, zapatos, ropa, etc." value={actividadcomercio} maxLength="50" onChange={this.TextInput} autoComplete="off" />
                                </div>}
                                {asociadoverificado && <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                                    <label className="title-label form-label d-block fw-bold mb-1">
                                        <MDBTooltip domElement tag="span">
                                            <span>Agencia de Entrega <span className="text-danger">*</span></span>
                                            <div> Selecciona la agencia para la entrega del material (hablador y sticker QR)</div>
                                        </MDBTooltip>
                                    </label>
                                    
                                    <Select
                                        className="react-select-container" name="idagenciaentrega" options={redagencias} styles={getCustomSelectStyles()}
                                        value={opciones.idagenciaentrega} placeholder="Selecciona…" onChange={selected => this.SelectInput(selected, 'idagenciaentrega')}
                                        isClearable
                                    />
                                </div>}
                            </div>;
        const autorizacion =    <div className="container-fluid px-5">
                                    <p className="font-weight-bold">Autorización</p>
                                    <p className="text-justify">
                                       Al diligenciar y enviar este formulario, autorizo de manera libre, previa, expresa e informada a UTRAHUILCA, en calidad de responsable del tratamiento de datos personales. Autorizo para gestionar los procesos de vinculación, la solicitud y habilitación del código QR, la prestación de productos y servicios, así como las relaciones precontractuales, contractuales y pos contractuales con los titulares. Declaro que la información suministrada es veraz, completa y actualizada.
                                    </p>
                                    <hr className="bg-dark" />
                                    <div className="pt-1 d-flex align-items-center">
                                        <input type="checkbox" onClick={(evento) => { this.setState({ solicitudaceptada: evento.target.checked }) }} checked={this.state.solicitudaceptada} />&nbsp;<span className="font-weight-bold mt-0 pt-0 "> Autorización para generación de código QR </span>
                                    </div>
                                </div>;
        const deshabilitado = !asociadoverificado ? !(idtipodoc > 0 && iddocumento.trim().length >= 3 && numerocelular.trim().length >= 10) : !(idcodprocuenta > 0 && (llaveid === 4 ? llaveusuario !== '': llaveid > 0) && actividadcomercio !== '' && idagenciaentrega > 0 && solicitudaceptada);
        const botonformulario = <div className="d-flex justify-content-center my-3" onClick={() => {
                                    if (!deshabilitado) {
                                        if (!asociadoverificado) {
                                            this.VerificarAsociado();
                                        }
                                        else {
                                            this.EnviarCorreo();
                                        }
                                    }
                                }}>
                                    <button className="btn btn-positive" style={{ color: 'white' }} disabled={deshabilitado}>
                                        <span className="btn-text">{!asociadoverificado ? 'Continuar' : 'Enviar Solicitud'}</span>
                                    </button>
                                </div>;

        const jsx = <>
            <Header id={2} />
            <MensajeF />
            {direccionmodulo}
            {infomodulo}
            {formulario}
            {asociadoverificado && autorizacion}
            {botonformulario}
            {ejecutaloading && <Loading />}
            <Footer />
        </>;

        return jsx;
    }
}

export default FormSolicQrComercio;